import { render } from "./JobView.vue?vue&type=template&id=66ca1d26"
import script from "./JobView.vue?vue&type=script&lang=js"
export * from "./JobView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__